import Modal from './Modal'

const { show, hide } = Modal

export default Modal

export { show, hide }
